import { Component } from "@angular/core";

@Component({
	selector: "sdi-homepage-about-us",
	templateUrl: "./homepage-about-us.component.html",
	styleUrls: ["./homepage-about-us.component.scss"]
})
export class HomepageAboutUsComponent {}
